var exports = {
  "rf": "VoiceMessageComposerModal.module__body___UW5wQV",
  "BK": "VoiceMessageComposerModal.module__helpText___UW5wQV",
  "kc": "VoiceMessageComposerModal.module__errorText___UW5wQV",
  "mI": "VoiceMessageComposerModal.module__meta___UW5wQV",
  "sG": "VoiceMessageComposerModal.module__recordingStatus___UW5wQV",
  "ne": "VoiceMessageComposerModal.module__controls___UW5wQV",
  "hZ": "VoiceMessageComposerModal.module__buttonInner___UW5wQV",
};

module.exports = exports;
